import { postRequired } from "./apiClient";

export interface RefreshRunsSummary {
  windowStart: string;
  windowEnd: string;
  synapse?: {
    jobsChecked: number;
    runsDiscovered: number;
    runsUpserted: number;
    errors: Array<{ message: string }>;
  };
  acr?: {
    jobsChecked: number;
    runsDiscovered: number;
    runsUpserted: number;
    errors: Array<{ message: string }>;
  };
  sqlEtl?: {
    jobsChecked: number;
    runsDiscovered: number;
    runsUpserted: number;
    errors: Array<{ message: string }>;
  };
  powerBi?: {
    workspacesChecked: number;
    jobsChecked: number;
    semanticModelsDiscovered: number;
    refreshesDiscovered: number;
    runsUpserted: number;
    errors: Array<{ message: string }>;
  };
}

export function refreshRunHistory(): Promise<RefreshRunsSummary> {
  return postRequired<Record<string, never>, RefreshRunsSummary>("/admin/refresh-runs", {});
}
